/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import './sideMenu.css'

import { getUser } from 'adalConfig'
import classNames from 'classnames'
import Logo from 'components/Logo'
import Config from 'config'
import { setLocale } from 'locale/momentLocale'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import type { Translate } from 'types'

import BugReportIcon from '@mui/icons-material/BugReport'
import Box from '@mui/material/Box'

interface Props {
  behalfOfUserName: string | null
  isMenuOpened: boolean
  lang: string
  logout: any
  setLanguage: (language: string) => void
  setUseLocalCurrency: (payload: { useLocalCurrency: boolean }) => void
  t: Translate
  toggleMenu: () => void
  toggleReportBugDialog: () => void
  useLocalCurrency?: boolean
  i18n?: any
}

class SideMenu extends Component<Props> {
  componentDidMount() {
    const { lang } = this.props
    const isInvalidTranslate = this.props.t('config.language') !== lang

    if (isInvalidTranslate) {
      this.forceUpdate()
    }
  }

  setPLLanguage = () => {
    if (this.props.lang !== 'pl') {
      this.setLanguage('pl')
    }
  }

  setENLanguage = () => {
    if (this.props.lang !== 'en') {
      this.setLanguage('en')
    }
  }

  setLanguage = (lang: string) => {
    localStorage.setItem('lang', lang)
    this.props.setLanguage(lang)
    this.props.i18n.changeLanguage(lang)
    localStorage.setItem('i18nextLng', lang)
    setLocale(lang)
  }

  handleSideMenuClick = () => {
    if (this.props.isMenuOpened) {
      this.props.toggleMenu()
    }
  }

  handleCloseClick = (event: any) => {
    // prevent firing double click (see .side-menu)
    event.stopPropagation()
    event.preventDefault()
    this.props.toggleMenu()
  }

  setUseLocalCurrency = (value: boolean) => this.props.setUseLocalCurrency({ useLocalCurrency: value })

  render() {
    const { behalfOfUserName, lang, useLocalCurrency } = this.props
    const user = getUser()

    return (
      <Box
        className={classNames('side-menu', {
          'is-shown': this.props.isMenuOpened,
        })}
      >
        <Box className="side-menu_wrapper">
          <Box className="side-menu_header">
            <Box className="tap-area" onClick={this.handleCloseClick}>
              <i className="icon close-icon" />
            </Box>
            <Box className="side-menu_header-logo">
              <Logo />
            </Box>
            {user?.profile && (
              <Box className="side-menu_header-user-info">
                <h3>{user.profile.name}</h3>
                <p>{user.profile.email}</p>
                {behalfOfUserName && (
                  <p>
                    {this.props.t('menu.behalfOfUserName', {
                      user: behalfOfUserName,
                    })}
                  </p>
                )}
              </Box>
            )}
          </Box>
          <ul className="side-menu_options">
            <li>
              <Box className="icon language-icon" />
              <span>{this.props.t('menu.language.title')}</span>
              <ul className="side-menu_options-submenu">
                <li className="second-level">
                  <input type="radio" name="language" id="pl" value="pl" checked={lang === 'pl'} onChange={this.setPLLanguage} />
                  <label htmlFor="pl" onClick={this.setPLLanguage}>
                    {this.props.t('menu.language.polish')}
                  </label>
                </li>
                <li className="second-level">
                  <input type="radio" name="language" id="en" value="en" checked={lang === 'en'} onChange={this.setENLanguage} />
                  <label htmlFor="en" onClick={this.setENLanguage}>
                    {this.props.t('menu.language.english')}
                  </label>
                </li>
              </ul>
            </li>
            <li>
              <Box className="icon fm fm-dollar" />
              <span>{this.props.t('menu.localCurrency.title')}</span>
              <ul className="side-menu_options-submenu">
                <li className="second-level">
                  <input
                    type="radio"
                    name="local-currency"
                    id="yes"
                    value="true"
                    checked={!!useLocalCurrency}
                    onChange={() => this.setUseLocalCurrency(true)}
                  />
                  <label htmlFor="yes" onClick={() => this.setUseLocalCurrency(true)}>
                    {this.props.t('menu.localCurrency.yes')}
                  </label>
                </li>
                <li className="second-level">
                  <input
                    type="radio"
                    name="local-currency"
                    id="no"
                    value="false"
                    checked={!useLocalCurrency}
                    onChange={() => this.setUseLocalCurrency(false)}
                  />
                  <label htmlFor="no" onClick={() => this.setUseLocalCurrency(false)}>
                    {this.props.t('menu.localCurrency.no')}
                  </label>
                </li>
              </ul>
            </li>
            <li>
              <Box className="icon info-icon" />
              <span>{this.props.t('menu.info')}</span>
              <span className="side-menu_help">{`v ${Config.version}`}</span>
            </li>
            <li onClick={this.props.toggleReportBugDialog}>
              <BugReportIcon className="bug-report-icon" />
              <span>{this.props.t('menu.reportBug')}</span>
            </li>
            <li>
              <Box className="icon logout-icon" />
              <span>{this.props.t('menu.logout')}</span>
            </li>
          </ul>
        </Box>
      </Box>
    )
  }
}

export default withTranslation()(SideMenu) as any
